import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgClipboard = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.32 5.75h-1.674C14.366 4.466 13.306 3.5 12 3.5s-2.396.966-2.646 2.25H7.68C6.487 5.75 5.52 6.758 5.52 8v11.25c0 1.242.967 2.25 2.16 2.25h8.64c1.193 0 2.16-1.008 2.16-2.25V8c0-1.242-.969-2.25-2.16-2.25M12 5.188c.447 0 .81.378.81.843s-.365.844-.81.844-.81-.379-.81-.844.365-.843.81-.843m4.86 14.062c0 .31-.242.563-.54.563H7.68a.55.55 0 0 1-.54-.563V8c0-.31.242-.562.54-.562h.616c-.045.179-.076.365-.076.562v.563c0 .309.242.562.54.562h6.48c.298 0 .54-.252.54-.562V8c0-.195-.031-.382-.076-.562h.616c.298 0 .54.252.54.562z"
    }));
export default SvgClipboard;
